<script setup lang="ts"></script>

<template>
  <div class="container">
    <p class="fw-bold">お好み条件から探す</p>
  </div>
  <div class="container condition">
    <div class="card">
      <CardConditionFindCars />
    </div>
  </div>
</template>
<style scoped>
.condition .card {
  padding: 0px 10px 0px 10px;
  box-shadow: 0 0 2px rgb(0 0 26 / 15%);
  border: none;
  margin-bottom: 15px;
}

.condition .card .item_title {
  font-size: 14px;
}
</style>
